import { CartAddEvent } from "@theme/events";

/**
 * Enhances the app drawer used for the cart with auto-open on CartAddEvent.
 * The drawer itself is a standard <drawer-component> (from app-drawer.js).
 * Cart DOM updates are handled independently by <cart-items-component>.
 */
function initCartDrawer() {
  const cartDrawer = document.querySelector("drawer-component#cart-drawer");
  if (!cartDrawer) return;

  document.addEventListener(CartAddEvent.eventName, (event) => {
    if (event.detail?.data?.didError) return;
    if (cartDrawer.hasAttribute("auto-open")) {
      cartDrawer.open();
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartDrawer);
} else {
  initCartDrawer();
}
